module.exports = __webpack_public_path__ + "img/Loong5.0daba090.png";